<template>
  <v-card data-e2e-id="reminder-dialog" flat class="pa-4">
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <div>
        <v-row>
          <v-col cols="3">
            Remind me in:
          </v-col>
          <v-col cols="9">
            <app-button
              id="button-day"
              :outlined="buttonSelected !== 'days'"
              class="mr-1"
              @click="setDate('days')"
              >1 day</app-button
            >
            <app-button
              id="button-week"
              :outlined="buttonSelected !== 'weeks'"
              class="mx-1"
              @click="setDate('weeks')"
              >1 week</app-button
            >
            <app-button
              id="button-month"
              :outlined="buttonSelected !== 'months'"
              class="mx-1"
              @click="setDate('months')"
              >1 month</app-button
            >
          </v-col>
        </v-row>
        <v-row class="pb-5">
          <v-col cols="3" class="pb-0">Custom</v-col>
          <v-col cols="9" class="pb-0">
            <app-date-picker
              id="reminder-date"
              outlined
              :schema="datepickerSchema"
              :model="date"
              :min-date="tomorrow"
              @change="onDatePickerChange"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" class="py-0">Time</v-col>
          <v-col cols="9" class="py-0">
            <v-row>
              <v-col cols="8" class="py-0">
                <v-select
                  v-model="time"
                  outlined
                  background-color="light"
                  label="Select time"
                  :items="timeOptions"
                />
              </v-col>
              <v-col cols="4" class="py-0">
                <v-select v-model="amPm" outlined background-color="light" :items="amPmOptions" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" class="py-0">Note</v-col>
          <v-col cols="9" class="py-0" data-e2e-id="reminder-dialog-note">
            <v-textarea
              v-model="note"
              outlined
              background-color="light"
              maxlength="100"
              :counter="100"
            ></v-textarea>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <v-card-actions>
      <slot name="actions"></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'

export default {
  props: {
    title: { type: String, default: '' },
    reminder: { type: Object, default: () => {} }
  },
  data() {
    return {
      buttonSelected: 'days',
      date: moment()
        .add(1, 'days')
        .format(),
      time: 0,
      amPm: 'am',
      note: null,
      datepickerSchema: {
        label: 'Select Date',
        required: true
      }
    }
  },
  computed: {
    tomorrow() {
      return moment()
        .startOf('day')
        .add(1, 'days')
        .format()
    },
    hour() {
      if (this.amPm === 'am') {
        return this.time
      }
      return this.time + 12
    },
    timeOptions() {
      return [
        {
          text: '1',
          value: 1
        },
        {
          text: '2',
          value: 2
        },
        {
          text: '3',
          value: 3
        },
        {
          text: '4',
          value: 4
        },
        {
          text: '5',
          value: 5
        },
        {
          text: '6',
          value: 6
        },
        {
          text: '7',
          value: 7
        },
        {
          text: '8',
          value: 8
        },
        {
          text: '9',
          value: 9
        },
        {
          text: '10',
          value: 10
        },
        {
          text: '11',
          value: 11
        },
        {
          text: '12',
          value: 0
        }
      ]
    },
    amPmOptions() {
      return [
        {
          text: 'AM',
          value: 'am'
        },
        {
          text: 'PM',
          value: 'pm'
        }
      ]
    }
  },
  created() {
    this.resetForm()
  },
  methods: {
    setDate(timeUnit) {
      this.buttonSelected = timeUnit
      this.date = moment()
        .add(1, timeUnit)
        .format()
    },
    onDatePickerChange(event) {
      if (event.valid) {
        this.buttonSelected = null
        this.date = moment(event.value).format()
      } else {
        this.date = null
      }
    },
    resetForm() {
      this.buttonSelected = 'days'
      if (!_.isEmpty(this.reminder)) {
        this.note = this.reminder.note
        const localDate = moment(this.reminder.reminderTimestamp)
        this.date = localDate.format()
        const hour = parseInt(localDate.format('H'))
        if (hour < 12) {
          this.time = hour
          this.amPm = 'am'
        } else {
          this.amPm = 'pm'
          if (hour > 12) {
            this.time = hour - 12
          } else {
            this.time = hour
          }
        }
      } else {
        this.note = null
        this.date = moment()
          .add(1, 'days')
          .format()
        this.time = 0
        this.amPm = 'am'
      }
    },
    getReminder() {
      if (this.date !== null) {
        const reminderTimestampMoment = moment(this.date)
        reminderTimestampMoment.hours(this.hour)
        reminderTimestampMoment.minutes(0)
        reminderTimestampMoment.seconds(0)

        return {
          note: this.note,
          reminderTimestamp: reminderTimestampMoment.utc().format()
        }
      } else return null
    }
  }
}
</script>

<style lang="scss" scoped></style>
